import { PredictionResult } from "./PredictionResult";
import { PointSet } from "./PointSet";
import { IPointSetHolder } from "./IPointSetHolder";

export class EmptyPointSet implements IPointSetHolder {
  PointSet: PointSet = null;
  Type: string = "emptyPointSet";
}
